import { Outlet } from "react-router-dom";

const PrescriptionHistory = () => {

    return <Outlet />
}

export default PrescriptionHistory;